import { render, staticRenderFns } from "./ModalTipoDocumento.vue?vue&type=template&id=e9e1e5ee&scoped=true"
import script from "./ModalTipoDocumento.vue?vue&type=script&lang=js"
export * from "./ModalTipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e1e5ee",
  null
  
)

export default component.exports